import { useEffect, useMemo, useState } from "react";
import { createPortal } from "react-dom";
interface IReparentableProps {
  uid: string;
  children: any;
  path: string[];
}

const createParentable = (): HTMLDivElement => {
  const reparent = document?.createElement("div");
  reparent.setAttribute("style", "display: flex; width: 100%;");
  return reparent;
};

/**
 * Component used to allow movement of mosaic windows without having to remount them (when possible).
 * @param props - props include the unique mosaic window id and the child components housed within.
 */
export const Reparentable = (props: IReparentableProps): JSX.Element => {
  const { uid, children, path } = props;
  const [storedPath, setStoredPath] = useState<string | null>(null);
  const el: HTMLDivElement = useMemo(() => createParentable(), []);
  const key = `${uid}-panel`;

  useEffect(() => {
    // Only append children if initialized or path changes.
    if (storedPath !== path.toString()) {
      const mountNode = document.getElementById(uid + "-reparentable");
      while (mountNode.firstChild) {
        mountNode.removeChild(mountNode.firstChild);
      }
      mountNode.appendChild(el);
      setStoredPath(path.toString());
    }
  }, [uid, el, path, storedPath]);

  return createPortal(children, el, String(key));
};
